import { createAsyncThunk } from "@reduxjs/toolkit";
import { clientInvestSdk } from "@utils/clientInvestSdk";
import { logException } from "../../helpers/logException/logException";
import {
  IfIsaAccount,
  IfIsaTransfer,
  IfIsaYearlyContribution,
} from "@ifgengineering/client-invest-sdk";

export const fetchIfIsaAccountAPI = createAsyncThunk<IfIsaAccount | null, void>(
  "IFISA:FETCH_ACCOUNT",
  async (_, { rejectWithValue }) => {
    try {
      const response = await clientInvestSdk.getIfIsaAccount();

      return response.data;
    } catch (e: any) {
      if (e.response.status !== 401) {
        logException({
          tag: "fetchIfIsaAccountAPI",
          exception: e,
        });
      }

      return rejectWithValue(e?.message || "Failed to fetch IF-ISA account");
    }
  }
);

export const fetchIfIsaYearlyContributionAPI = createAsyncThunk<
  IfIsaYearlyContribution | null,
  void
>("IFISA:FETCH_YEARLY_CONTRIBUTION", async (_, { rejectWithValue }) => {
  try {
    const response =
      await clientInvestSdk.getYearlyContributionForCurrentYear();

    return response.data;
  } catch (e: any) {
    if (e.response.status !== 401) {
      logException({
        tag: "fetchIfIsaYearlyContributionAPI",
        exception: e,
      });
    }

    return rejectWithValue(
      e?.message || "Failed to fetch IF-ISA yearly contribution"
    );
  }
});

export const fetchIfIsaTransfersAPI = createAsyncThunk<IfIsaTransfer[], void>(
  "IFISA:FETCH_TRANSFERS",
  async (_, { rejectWithValue }) => {
    try {
      const response = await clientInvestSdk.getMyIfIsaTransfers();

      return response.data;
    } catch (e: any) {
      if (e.response.status !== 401) {
        logException({
          tag: "fetchIfIsaTransfersAPI",
          exception: e,
        });
      }

      return rejectWithValue(e?.message || "Failed to fetch IF-ISA transfers");
    }
  }
);
